import './App.scss';
import NavBar from "./components/NavBar";
import "./i18n";
import Home from "./components/Home";
import Footer from "./components/Footer";

function App() {


    return (
        <div className="App">
            <NavBar/>
            <div className={"content"}>
                <Home/>
                <Footer/>
            </div>
        </div>
    );
}

export default App;
